export default __webpack_public_path__ + "static/media/google-play-badge-nl.966b2800.png";